import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function StickyTopBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-dark text-white py-2 px-4 shadow-md" data-id="element-325">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-2 md:gap-4 text-sm md:text-base" data-id="element-326">
        <div className="flex items-center gap-2 font-bold text-center" data-id="element-327">
          <span className="animate-pulse" data-id="element-328">⏰</span>
          <span data-id="element-329">OFERTA POR TIEMPO LIMITADO — Cierra en:</span>
          <span className="text-brand-amber font-black text-lg tracking-wider" data-id="element-330">
            {formatTime(hours)}:{formatTime(minutes)}:{formatTime(seconds)}
          </span>
        </div>
        <a href="#compra" className="bg-brand-green hover:bg-[#15803d] text-white font-bold py-1 px-4 rounded-full text-sm transition-colors whitespace-nowrap" data-id="element-331">
          ASEGURAR MI PRECIO
        </a>
      </div>
    </div>;
}